<template>
  <div class="board-member-box" v-cloak>

    <vue-check-viewport tag="div" v-for="(item,index) in content" :key="index" class="board-member" @on-visible="onVisible(index)">
      <div class="board-member-avatar"><img :src="item['avatar']" alt=""></div>
      <div class="board-member-name"><span>{{item['title']}}</span></div>
      <div class="board-member-summary">{{item['dutyIntroduce']}}</div>
      <div class="board-member-description" v-html="item['description']"></div>
    </vue-check-viewport>

  </div>
</template>
<script>
import VueCheckViewport from 'vue-check-viewport';
import Bus from '../../router/bus.js';
/**
 * 公司治理-董事会成员
 */
export default {
  name: 'BoardMember',
  components: {
    VueCheckViewport
  },
  data () {
    return {
      cat: 8000002,
      content: []
    }
  },
  created() {
    Bus.$emit('changeCat', this.cat)
    let url = this.$root.baseUrl + '/boardMember/list/all';
    this.axios.get(url)
      .then(res => {
        this.content = res['data'];
        console.log(res);
      })
      .catch(e => {
        console.log(e);
      });
  },
  methods: {
    onVisible(index) {
      let item = this.content[index];
      console.log(item);
      if (!item['viewed']) {
        console.log('viewed');
        item['viewed'] = true;
        this.axios.get(this.$root.baseUrl + '/boardMember/hits/' + item['id']);
      }
    }
  }
}
</script>
<style scoped>
  .board-member-box {
    font-size: 1rem;
  }
  .board-member {
    width: 90vw;
    margin: 5vw;
  }
  .board-member-avatar img {
    width: 100%;
  }
  .board-member-name {
    font-weight: 600;
    color: #ebcc95;
    padding: 1rem 0;
  }
  .board-member-name span {
    display: block;
    border-left: 3px solid #ebcc95;
    padding-left: .5rem;
    line-height: 1.5rem;
    font-size: 1.5rem;
  }
  .board-member-summary {
    padding-bottom: 1rem;
  }
  .board-member-description {
    line-height: 1.5rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/investor/BoardMember.vue